export enum PrintableCalendarAspectRatios {
  tabloid = "tabloid",
  letter = "letter",
  a4 = "a4",
  a3 = "a3"
}